'use client';

import { SVGProps } from 'react';
import PinSvg from '../../../../public/images/careers/pin.svg';

type Props = {} & SVGProps<SVGSVGElement>;

export default function Pin(props: Props) {
    return <PinSvg {...props} />;
}
